import { createBrowserHistory } from "history";
const history = createBrowserHistory({ hashType: "slash" });

export default history;
